import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { ITBQuoteEditBidComponent } from '../itb-quote-edit-bid/itb-quote-edit-bid.component';
import { Router } from '@angular/router';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-itb-quote-edit-confirm-bid',
    templateUrl: './itb-quote-edit-confirm-bid.component.html',
    styleUrls: ['./itb-quote-edit-confirm-bid.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class ITBQuoteEditConfirmBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  div1:boolean=true;
  activeTab = 'none';
  priceTab= 'none';
  @Input() parameter:any;
  @Input() multipleProduct: any;
  @Input() tabName: any;
  @Input() materialFixedPrice1: number;
  @Input() materialIndexPrice1: number;
  @Input() price:any;
  @Input() indexValue:any;
  productInfo:any;
  priceVal: any;
tabValue:any;
  additionalTerms: any;
  requestParams: any;
  reqTenderEntries:any = [];
  enableLoader: boolean = false;
  confirmTxt: string = null;
  constructor( private router: Router,private customProductService: CustomProductsService,public activeModal: NgbActiveModal,private Modal:NgbModal, 
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    console.log(this.parameter);
    this.productInfo=this.multipleProduct.quoteEntries;
    this.additionalTerms=this.multipleProduct?this.multipleProduct.buyerRemarks:'';
    console.log(this.multipleProduct.buyerRemarks,'bt')
    this.tabValue=this.tabName;
    this.productInfo.map((val)=>{
      this.reqTenderEntries.push({
        "entryNumber": val.entryNumber,
        // "maximumQuantity": val.product.maximumQty,
        // "minimumQuantity": val.product.minimumQty,
        
        // "pricingBasis": {
        //     "code": val.pricingBasis.code,
        //     "description": val.pricingBasis.description
        // },
        "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
        "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
        "pricingOptionsEnum": [
          {
            "pricingOptions": val.pricingOptionsEnum[0].pricingOptions,
            "qpMultipleChoices": val.pricingOptionsEnum[0].qp
          }
        ],
        "productCode": val.productCode,
        "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
        "dischargePortDetails":val.isDischargePortUnrestricted==true ? val.dischargePortshw:'',
        "quantity":val.isQuantityUnrestricted==true?val.quantityshw:val.quantity,
        // "productName": val.productName,
        // "quantity": val.quantity,
  
        // "quotationPeriod": {
        //     "code": val.defaultQuotationPeriod.code,
        //     "description": val.defaultQuotationPeriod.description
        //   },
         "rcPrice": {
        "currencyIso": "USD",
        "value": val.rcPrice?val.rcPrice.value:''
      },
      "tcPrice": {
        "currencyIso":"USD",
        "value": val.tcPrice.value
      }
      })
    })
  }
  backToPlacebid(): any{
    this.activeModal.close();
    const ModalRef = this.Modal.open(ITBQuoteEditBidComponent,{centered: true,size:'md'});
    this.indexValue = this.multipleProduct.quoteEntries.length-1;

      ModalRef.componentInstance.indexValue = this.indexValue;
      ModalRef.componentInstance.index=this.parameter;
    ModalRef.componentInstance.code=this.multipleProduct;
    console.log('back.......from confirm....',this.multipleProduct.quoteEntries[this.indexValue]);
    
      if(this.productInfo){
        ModalRef.componentInstance.defaultValue = this.multipleProduct.quoteEntries[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
        ModalRef.componentInstance.tabName = this.tabValue;
          ModalRef.componentInstance.price=this.multipleProduct.quoteEntries[this.indexValue].tcPrice.value;
           ModalRef.componentInstance.indexPrice=this.multipleProduct.quoteEntries[this.indexValue].rcPrice.value;
      }
      if(this.multipleProduct.quoteEntries[this.indexValue].pricingOptionsEnum[0]?.qp){
        ModalRef.componentInstance.defaultValue = this.multipleProduct.quoteEntries[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
          ModalRef.componentInstance.displayFixedQPSection = true;
          ModalRef.componentInstance.finalQPFromDate= this.multipleProduct.quoteEntries[this.indexValue].finalQPFromDate;
          ModalRef.componentInstance.finalQPToDate= this.multipleProduct.quoteEntries[this.indexValue].finalQPToDate;
        }else{
          ModalRef.componentInstance.displayFixedQPSection = false;
        }
      }
    }
    submitBid(): any{
      for(let RC of this.reqTenderEntries){
        if(this.parameter[this.indexValue].displayRCPriceConfig.displayRCPrice==false){
          delete RC.rcPrice
        }
      }
      console.log(this.reqTenderEntries,'reqTenderEntries')
      this.requestParams = {
        "quoteAction": "EDIT_BID",
        "tender": {
          "buyerRemarks": this.additionalTerms,   
          "quoteCode": this.multipleProduct.quoteCode,
          "tenderEntries": this.reqTenderEntries
        }
      }
      console.log(this.requestParams);
    this.enableLoader = true;
      this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
        if(resp.status === 'BID_PLACED'){
          this.enableLoader = false;
          this.customProductService.bidPlaced = true;
          //this.toastrService.show(resp.status );
          this.activeModal.close();
          const currentUrl = this.router.url;
          if (currentUrl === '/quotes/myquotes') {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          });
          }else{
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl] );
            });
          }
        }else{
          this.enableLoader = false;
          this.toastrService.show('unable  to submit due to error:'+(resp.status) );
        }
      },
      err=>{
        this.enableLoader = false;this.activeModal.close();
        this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
      })
    }
    formatQPDates(data){
      return this.customProductService.formatQPDates(data);
    }
    getDate(date){
      if(date){
        var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
        return formateDate;
      }
      else{
        return '';
      }
  
    }
}
